export default __webpack_public_path__ + "static/media/loading.a5f3206c.a5f3206c.gif";